import 'fancy-file-uploader/fancy_fileupload.css';
import 'fancy-file-uploader/jquery.fileupload';
import 'fancy-file-uploader/jquery.iframe-transport';
import 'fancy-file-uploader/jquery.fancy-fileupload';